import { Controller } from "stimulus";
import { useClickOutside } from 'stimulus-use';

export default class extends Controller {
  static targets = ['button', 'menu'];

  connect() {
    this.expanded = false;
    this.initializeClassName = this.menuTarget.className;

    useClickOutside(this)
  }

  toggle() {
    if (this.expanded) {
      this.buttonTarget.setAttribute('aria-expanded', 'false');
      this.menuTarget.classList.remove('opacity-100');

      setTimeout(() => {
        this.menuTarget.className = this.initializeClassName;
      }, 200);

    } else {
      this.buttonTarget.setAttribute('aria-expanded', 'true');
      this.menuTarget.classList.remove('hidden');

      requestAnimationFrame(() => {
        this.menuTarget.classList += ' flex-col opacity-100 border-b border-gray-500';
      });
    }

    this.expanded = !this.expanded;
  }

  clickOutside() {
    if (this.expanded) {
      this.toggle();
    }
  }
}
